import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBuildingBlocks: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="building-blocks, skills, stack"><path d="M20.9999 6.5L13 2L3 8.5V17.5L11 22L20.9999 15.5V6.5Z" stroke="currentColor" strokeWidth="1.5"/><path d="M20.9999 6.5L11 13L3 8.5" stroke="currentColor" strokeWidth="1.5"/><path d="M20.9999 11L11 17.5L3 13" stroke="currentColor" strokeWidth="1.5"/><path d="M11 22V13" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBuildingBlocks;
